var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('iframe',{attrs:{"width":"100%","src":_vm.src,"frameborder":"0","scrolling":"no","id":"test","onload":_vm.reinitIframe}})])
}
var staticRenderFns = []

export { render, staticRenderFns }